module.exports = __webpack_public_path__ + "img/v4_assetsBalance.d4498f84.png";